import React from 'react'
import ReactDOM from 'react-dom'

import './stylesheets/global.css'

// This is the root component. Strict mode and hot loading are defined there.
import App from './App'

ReactDOM.render(<App />, document.getElementById('app'))
